import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import { ShieldCheck, User, Lock, Loader2, ArrowLeft } from 'lucide-react'
import { BASE_URL } from '../../services/api'
import '../../styles/AuthLayout.css'

export default function AccountSetup() {
  const { state, dispatch } = useApp()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    fullName: '',
    mobile: state.pendingRegistration?.phone || '',
    password: '',
    confirmPassword: ''
  })
  const [errors, setErrors] = useState({})

  const companyId = state.pendingRegistration?.companyId || '1'

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newErrors = {}
    if (!formData.fullName) newErrors.fullName = 'Full name is required'
    if (!formData.mobile) newErrors.mobile = 'Mobile number is required'
    if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters'
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match'

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}Auth/set-password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          Companyid: companyId,
          FullName: formData.fullName,
          Mobile: formData.mobile,
          Password: formData.password
        })
      })
      const data = await response.json()
      if (data.success) {
        dispatch({ type: 'LOGIN', payload: { ...data.user, Companyid: companyId } })
        window.location.href = '/'
      } else {
        alert(data.message || 'Failed to set password')
      }
    } catch (err) {
      console.error(err)
      alert('Error during account setup. Please try again.')
    }
    setLoading(false)
  }

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: '420px' }}>
        <div className="auth-header" style={{ background: 'linear-gradient(135deg, #10b981, #1e2a3a)', padding: '28px 20px' }}>
          <div className="auth-logo" style={{ fontSize: '36px' }}>🛡️</div>
          <h1 className="auth-title" style={{ fontSize: '18px' }}>Petro Genius</h1>
          <p className="auth-subtitle">Administrator Account Setup</p>
        </div>

        <div className="auth-body" style={{ padding: '28px 32px' }}>
          <h2 className="auth-title-dark">Setup Admin</h2>
          <p className="auth-subtitle-dark" style={{ marginBottom: '24px' }}>Finalize your secure login credentials</p>

          <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '2px' }}>
            <div className="auth-field">
              <label>Administrator Name *</label>
              <input name="fullName" value={formData.fullName} onChange={handleInputChange} className="auth-input" placeholder="Enter Full Name" />
              {errors.fullName && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.fullName}</div>}
            </div>

            <div className="auth-field">
              <label>Mobile Number *</label>
              <input name="mobile" value={formData.mobile} onChange={handleInputChange} className="auth-input" placeholder="Contact Number" />
              {errors.mobile && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.mobile}</div>}
            </div>

            <div className="auth-field">
              <label>Create Password *</label>
              <input type="password" name="password" value={formData.password} onChange={handleInputChange} className="auth-input" placeholder="Min 6 characters" />
              {errors.password && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.password}</div>}
            </div>

            <div className="auth-field">
              <label>Confirm Password *</label>
              <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} className="auth-input" placeholder="Repeat password" />
              {errors.confirmPassword && <div style={{ color: '#c53030', fontSize: '11px', marginTop: '4px' }}>{errors.confirmPassword}</div>}
            </div>

            <div style={{ marginTop: '8px' }}>
              <button type="submit" className="auth-btn-primary" style={{ width: '100%', background: 'linear-gradient(135deg, #10b981, #059669)' }} disabled={loading}>
                {loading ? <Loader2 className="animate-spin" size={18} /> : 'Complete Setup'}
              </button>
            </div>
          </form>

          <div style={{ marginTop: '24px', textAlign: 'center' }}>
            <span onClick={() => window.location.href = '/'} style={{ fontSize: '13px', color: '#1a2b3c', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
              <ArrowLeft size={16} /> Back to Login
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
